import React from 'react'
import UserDropdown from '../components/header/UserDropdown'


const AppHeader = () => {
  return (
    <>
      <div className="navbar-header" style={{ borderBottom: '1px solid #E6E7E8', background: '#FBFCFE',zIndex:'999' }}>
        <div className="row align-items-center justify-content-between">
          <div className="col-auto">
            <div className="d-flex flex-wrap align-items-center gap-4">
              <button type="button" className="sidebar-toggle">
                <iconify-icon
                  icon="heroicons:bars-3-solid"
                  class="icon text-2xl non-active"
                />
                <iconify-icon icon="iconoir:arrow-right" class="icon text-2xl active" />
              </button>
              <button type="button" className="sidebar-mobile-toggle">
                <iconify-icon icon="heroicons:bars-3-solid" class="icon" />
              </button>
            </div>
          </div>
          <div className="col-auto">
            <div className="d-flex flex-wrap align-items-center gap-3">
              {/* Language dropdown end */}




              <UserDropdown />
              {/* Profile dropdown end */}
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default AppHeader
